import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';
import CompletionPopup from '../completion-popup';

function PasswordChecker() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext();
    const [code, setCode] = useState("def check_password(password):\n\t# Write code here");
    const [output, setOutput] = useState('');
    const [isProblemFinished, setIsProblemFinished] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isStrongPassword, setIsStrongPassword] = useState(false);

    const options = { scrollbar: { alwaysConsumeMouseWheel: false, }, scrollBeyondLastLine: false, minimap: { enabled: false, } }

    function handleEditorChange(newValue, event) {
        setCode(newValue);
    }

    function handleInputChange(event) {
        setInputValue(event.target.value);
        setIsStrongPassword(checkPassword(event.target.value));
    }

    function checkPassword(password) {
        const specialChars = ['@', '!', '#'];
        return password.length >= 8 && specialChars.some(char => password.includes(char));
    }

    async function runCode() {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        };
        const response = await fetch(serverURL + "/check_password", requestOptions);
        const result = await response.json();
        if (result.error) {
            setIsProblemFinished(false);
            setOutput(result.error);
        } else if (result.verdict === "Fail") {
            setIsProblemFinished(false);
            setOutput(`Test password ${result.test} failed.\nExpected: ${result.expected}, got ${result.result} instead`)
        } else {
            setOutput("");
            setIsPopupOpen(true);
            startConfetti();
            setIsProblemFinished(true);
        }
    }

    function hidePopup() {
        setIsPopupOpen(false);
    }

    return (
        <div>
            {isPopupOpen &&
                <CompletionPopup title="All Test Cases Passed!" message="Well done, you've passed all test cases! Try your program below." hidePopup={hidePopup} />
            }
            <h1 className='blue'>Password Checker</h1>
            <p>
                Complete this function that checks if a given password is strong enough. A strong password consists of at least 8 characters and has at least one of the following special characters (!, @, #). Return <code>True</code> if the password is strong, otherwise <code>False</code> if the password is weak.
            </p>
            <p>Examples</p>
            <ul>
                <li><code>check_password(<span className='string'>"aj3@k"</span>)</code> returns <code>False</code> because the password is not at least 8 characters</li>
                <li><code>check_password(<span className='string'>"myPassword"</span>)</code> returns <code>False</code> because the password doesn't have a special character</li>
                <li><code>check_password(<span className='string'>"asldjf2@j@"</span>)</code> returns <code>True</code></li>
            </ul>

            <div className='row' style={{ alignItems: "flex-start" }}>
                <div style={{ width: (output || isProblemFinished) ? "50%" : "100%" }}>
                    <div className='editor-padding'></div>
                    <MonacoEditor theme='vs-dark' language='python' height="300px" value={code} onChange={handleEditorChange} options={options} />
                    <button className='primary-btn blue-bg' style={{marginTop: "5px"}} onClick={runCode}>Submit</button>
                </div>
                {isProblemFinished &&
                    (<div className='password-test'>

                        <div>
                            <input value={inputValue} onChange={handleInputChange} placeholder='Enter Password' className='input-text' />
                        </div>
                        <p>{isStrongPassword ? "Strong" : "Weak"} Password</p>
                    </div>)}
                {output && (<pre className='output' style={{ height: "300px" }}>{output}</pre>)}
            </div>
        </div>
    );
}

export default PasswordChecker;